import Button from '@mui/material/Button';
import Hidden from '@mui/material/Hidden';
import NavItem from './nav-item.jsx';
import React, {useCallback} from 'react';
import {DARK_THEME} from '@apps-common/ui-theme/Themes';
import {Link} from 'react-router-dom';
import {NavBar} from '@apps-common/ui-components';
import {ThemeProvider, styled} from '@mui/material/styles';
import {useAuth} from '@apps-common/auth-react';

const Navigation = styled('nav')(({theme}) => ({
  display: 'flex',
  alignItems: 'center',
  margin: theme.spacing(0, 3),
}));

export default function Header() {
  const auth = useAuth();

  const login = useCallback(() => auth.signIn(), [auth]);
  const logout = useCallback(() => {
    analytics.track('Logout Button clicked');
    auth.signOut();
  }, [auth]);

  const Nav = (
    <Navigation>
      <NavItem to="/" data-cy="nav-item-browse">
        Browse
      </NavItem>
      {auth.user && (
        <NavItem to="/my-stories" data-cy="nav-item-my-stories">
          My stories
        </NavItem>
      )}
      <Hidden smDown>
        <Button
          component={Link}
          color="primary"
          variant="contained"
          to="/create"
          data-cy="nav-item-create"
          size="small"
          sx={{
            padding: theme => theme.spacing(0.25, 1),
          }}
        >
          Create
        </Button>
      </Hidden>
    </Navigation>
  );
  return (
    <ThemeProvider theme={DARK_THEME}>
      <NavBar
        position="sticky"
        title="Stories"
        user={auth.user?.claims}
        logout={logout}
        login={login}
        appsMenuProps={{
          exclude: 'stories',
        }}
        primary={Nav}
      />
    </ThemeProvider>
  );
}
